import React from "react";
import '../App.css';

const FruitLoader = () => {
  return (
    <div className="fruit-loader">
      <img src="https://em-content.zobj.net/source/apple/237/red-apple_1f34e.png" alt="Manzana" className="fruit fruit-1" />
      <img src="https://symbl-cdn.com/i/webp/e2/cf117835d379859f54ec6fd8db6a1b.webp" alt="Banana" className="fruit fruit-2" />
      <img src="https://images.emojiterra.com/microsoft/fluent-emoji/15.1/512px/1f347_flat.png" alt="Uvas" className="fruit fruit-3" />
      <img src="https://images.emojiterra.com/twitter/v14.0/1024px/1f349.png" alt="Sandía" className="fruit fruit-4" />
      <img src="https://em-content.zobj.net/source/apple/118/strawberry_1f353.png" alt="Fresa" className="fruit fruit-5" />
      <img src="https://symbl-cdn.com/i/webp/0b/ffbc4b08ef450bde8967b5528f567d.webp" alt="Piña" className="fruit fruit-6" />
    </div>
  );
};

export default FruitLoader;
